import { Link } from 'react-router-dom'
import { Button } from '@/shared/ui/Button'

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-bg px-4 text-center">
      <p className="font-mono text-label text-ink-muted">404</p>
      <h1 className="text-2xl font-bold">Страница не найдена</h1>
      <p className="max-w-prose text-meta text-ink-soft">
        Возможно, ссылка устарела или в адресе опечатка.
      </p>
      <Link to="/">
        <Button variant="secondary">На главную</Button>
      </Link>
    </div>
  )
}
